export default "__VITE_ASSET__DNz7W2mi__"